"use client";

import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function Scoop() {
  const products = [{
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1709989/img/strawberry_swirl_pint.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1709989/img/strawberry_swirl_pint.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1709989/img/strawberry_swirl_pint.png-wvc-sizes",
    alt: "Artisanal strawberry swirl ice cream pint",
    position: "left"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1709989/img/salted_caramel_pint.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1709989/img/salted_caramel_pint.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1709989/img/salted_caramel_pint.png-wvc-sizes",
    alt: "Premium salted caramel ice cream pint",
    position: "center"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1709989/img/vanilla_bean_pint.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1709989/img/vanilla_bean_pint.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1709989/img/vanilla_bean_pint.png-wvc-sizes",
    alt: "Classic vanilla bean ice cream pint",
    position: "right"
  }];
  return <section data-section-id="17946" id="the-cold-craft" className="relative overflow-hidden bg-background py-32 md:py-44">
      {}
      <div className="pointer-events-none absolute inset-0 overflow-hidden">
        <div className="absolute -top-32 -left-24 h-[28rem] w-[28rem] rounded-lg opacity-50" style={{
        background: "var(--chart-1)",
        filter: "blur(80px)",
        animation: "drift1 28s ease-in-out infinite alternate"
      }} />
        <div className="absolute top-1/3 left-1/2 h-[32rem] w-[32rem] -translate-x-1/2 rounded-lg opacity-50" style={{
        background: "var(--chart-2)",
        filter: "blur(80px)"
      }} />
        <div className="absolute -bottom-24 -right-20 h-[30rem] w-[30rem] rounded-lg opacity-50" style={{
        background: "var(--chart-3)",
        filter: "blur(80px)",
        animation: "drift2 30s ease-in-out infinite alternate"
      }} />
        <div className="absolute -top-20 right-1/4 h-[24rem] w-[24rem] rounded-lg opacity-40" style={{
        background: "var(--chart-4)",
        filter: "blur(80px)"
      }} />
      </div>

      <style>{`
        @keyframes drift1 {
          0% { transform: translate(-8%, 0) rotate(0deg); }
          100% { transform: translate(8%, 4%) rotate(6deg); }
        }
        @keyframes drift2 {
          0% { transform: translate(6%, 0) rotate(0deg); }
          100% { transform: translate(-6%, -4%) rotate(-6deg); }
        }
        @keyframes bobLeft {
          0%, 100% { transform: translateY(0) rotate(-2deg); }
          50% { transform: translateY(-6px) rotate(-2deg); }
        }
        @keyframes bobCenter {
          0%, 100% { transform: translateY(0) rotate(1.5deg); }
          50% { transform: translateY(6px) rotate(1.5deg); }
        }
        @keyframes bobRight {
          0%, 100% { transform: translateY(0) rotate(-1deg); }
          50% { transform: translateY(-6px) rotate(-1deg); }
        }
        @media (prefers-reduced-motion: reduce) {
          .haze-drift, .float-card { animation: none !important; }
        }
      `}</style>

      <div className="relative mx-auto max-w-[1280px] px-5 md:px-10">
        {}
        <div className="mx-auto flex max-w-[920px] flex-col items-center text-center">
          <span className="font-default mb-6 text-[0.8125rem] font-medium uppercase text-muted-foreground" style={{
          letterSpacing: "0.14em"
        }}>
            Artisanal Summer Batch
          </span>

          <h1 className="font-default text-foreground" style={{
          fontWeight: 500,
          fontSize: "clamp(2.75rem, 5.6vw + 0.5rem, 5.5rem)",
          letterSpacing: "-0.03em",
          lineHeight: 1.02
        }}>
            Crafting frozen moments of{" "}
            <span className="font-serif italic" style={{
            color: "var(--primary)"
          }}>
              pure bliss
            </span>
          </h1>

          <p className="mt-7 max-w-[560px] text-muted-foreground" style={{
          fontWeight: 400,
          fontSize: "clamp(1.0625rem, 0.5vw + 0.9rem, 1.25rem)",
          letterSpacing: "-0.005em",
          lineHeight: 1.6
        }}>
            Experience our small-batch, hand-churned ice cream made with locally sourced cream and premium ingredients. A sophisticated treat for the modern palate.
          </p>

          <div className="mt-9 flex flex-col items-stretch gap-3 sm:flex-row sm:items-center">
            <Button asChild className="bg-primary px-7 py-6 text-primary-foreground shadow-lg hover:bg-primary/85 hover:shadow-xl" style={{
            borderRadius: "0px"
          }}>
              <Link to="/ShopPage">Shop our flavors</Link>
            </Button>
            <Button asChild variant="outline" className="border-border bg-card px-7 py-6 text-foreground backdrop-blur-md hover:border-primary/50 hover:bg-card hover:text-primary" style={{
            borderRadius: "0px"
          }}>
              <Link to="/TheArtisanalProcessPage">Our process</Link>
            </Button>
          </div>
        </div>

        {}
        <div className="relative mt-20 hidden md:block">
          <div className="relative mx-auto h-[28rem] max-w-[960px]">
            {}
            <div className="float-card absolute left-[6%] top-[12%] w-60 lg:w-64" style={{
            animation: "bobLeft 6s ease-in-out infinite alternate",
            zIndex: 1
          }}>
              <div className="group overflow-hidden border bg-card p-6 backdrop-blur-xl transition-all duration-300 hover:-translate-y-2 hover:shadow-2xl" style={{
              borderRadius: "0px",
              borderColor: "var(--border)",
              boxShadow: "var(--shadow-2xl)"
            }}>
                <div className="aspect-[3/4] overflow-hidden" style={{
                background: "var(--chart-1)"
              }}>
                  <img src={products[0].src} data-wvc-srcset={products[0].srcset} data-wvc-sizes={products[0].sizes} alt={products[0].alt} loading="lazy" decoding="async" className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
                </div>
                <div className="mt-4 flex items-center justify-between">
                  <span className="font-default text-sm font-medium text-foreground">Strawberry Swirl</span>
                  <span className="font-mono text-sm font-medium text-foreground">$12</span>
                </div>
              </div>
            </div>

            {}
            <div className="float-card absolute left-1/2 top-0 w-72 -translate-x-1/2 lg:w-80" style={{
            animation: "bobCenter 6s ease-in-out infinite alternate",
            zIndex: 3
          }}>
              <div className="group overflow-hidden border bg-card p-6 backdrop-blur-xl transition-all duration-300 hover:-translate-y-2 hover:shadow-2xl" style={{
              borderRadius: "0px",
              borderColor: "var(--border)",
              boxShadow: "var(--shadow-3xl)"
            }}>
                <div className="aspect-[3/4] overflow-hidden" style={{
                background: "var(--chart-2)"
              }}>
                  <img src={products[1].src} data-wvc-srcset={products[1].srcset} data-wvc-sizes={products[1].sizes} alt={products[1].alt} loading="lazy" decoding="async" className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
                </div>
                <div className="mt-4 flex items-center justify-between">
                  <span className="font-default text-sm font-medium text-foreground">Salted Caramel</span>
                  <span className="font-mono text-sm font-medium text-foreground">$14</span>
                </div>
              </div>
            </div>

            {}
            <div className="float-card absolute right-[6%] top-[14%] w-60 lg:w-64" style={{
            animation: "bobRight 6s ease-in-out infinite alternate",
            zIndex: 2
          }}>
              <div className="group overflow-hidden border bg-card p-6 backdrop-blur-xl transition-all duration-300 hover:-translate-y-2 hover:shadow-2xl" style={{
              borderRadius: "0px",
              borderColor: "var(--border)",
              boxShadow: "var(--shadow-2xl)"
            }}>
                <div className="aspect-[3/4] overflow-hidden" style={{
                background: "var(--chart-3)"
              }}>
                  <img src={products[2].src} data-wvc-srcset={products[2].srcset} data-wvc-sizes={products[2].sizes} alt={products[2].alt} loading="lazy" decoding="async" className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
                </div>
                <div className="mt-4 flex items-center justify-between">
                  <span className="font-default text-sm font-medium text-foreground">Vanilla Bean</span>
                  <span className="font-mono text-sm font-medium text-foreground">$10</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {}
        <div className="mt-14 md:hidden">
          <div className="mx-auto w-full max-w-sm border bg-card p-6 backdrop-blur-xl" style={{
          borderRadius: "0px",
          borderColor: "var(--border)",
          boxShadow: "var(--shadow-3xl)",
          animation: "bobCenter 6s ease-in-out infinite alternate"
        }}>
            <div className="aspect-[3/4] overflow-hidden" style={{
            background: "var(--chart-2)"
          }}>
              <img src={products[1].src} data-wvc-srcset={products[1].srcset} data-wvc-sizes={products[1].sizes} alt={products[1].alt} loading="lazy" decoding="async" className="h-full w-full object-cover" />
            </div>
            <div className="mt-4 flex items-center justify-between">
              <span className="font-default text-sm font-medium text-foreground">Salted Caramel</span>
              <span className="font-mono text-sm font-medium text-foreground">$14</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}